module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chptr"
  }, [_c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("CHAPTER ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("ORRESPONDENCE FROM MARGARET"), _c('br'), _vm._v(" COLVILLE TO EMMY Tibbett")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("2919 Mulberry Place"), _c('br'), _vm._v("Washington, D.C."), _c('br'), _vm._v("U.S.A.")]), _c('br'), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("November 30")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("My dear Emmy,")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("This is to let you know that John and I finally succumbed to your propaganda and went to the Caribbean for a holiday. In fact, we’re just back after spending Thanksgiving on your favorite island of Tampica.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("It was wonderful, and we can quite see why you and Henry love it so much—but with all the new hotels opening up, it’s beginning to get a bit crowded. Splendid for the island’s economy, of course, but not so good for unsociable vacationers like us. However, we took a day trip to St. Matthew’s, which is one of the British Seaward Islands (I believe there was some talk of St. Matthew’s joining with Tampica at the time of independence, but the islanders voted to stay British). We have quite lost our hearts to St. Matthew’s, which is just as you described Tampica before the big tourist boom. I have a feeling we shall be going back there.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("How is London? It seems a long time since we left, and we are becoming quite Americanized. John still enjoys his job with the World Bank here, and of course we love living in Georgetown—but already we’re beginning to think about retirement. It may sound a bit premature, but we both like the idea of doing something quite new and different while we’re still young enough. John says this is a depressing era for economists. Have you ever known one that wasn’t?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("We both send our love to both of you—")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Margaret")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("The Anchorage Inn"), _c('br'), _vm._v("St. Matthew’s"), _c('br'), _vm._v("British Seaward Islands"), _c('br'), _vm._v(" March 15")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Isn’t this a pretty little inn? Having a wonderful time. Wish you were here. Why do they make these cards so small? Will write later. Love, M.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("2919 Mulberry Place"), _c('br'), _vm._v("Washington, D.C. U.S.A."), _c('br'), _vm._v("April 5")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("My dear Emmy,")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("At last, the promised letter. As you’ll have gathered from my postcard, we had a marvelous holiday on St. Matthew’s. It’s a smaller island than Tampica, but much the same when it comes to scenery—a mountainous center covered in rain forest, miles of coral beaches and palm trees, and, of course, the incredible crystal-clear Caribbean.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("You remember the luxury hotel on Tampica, where you and Henry stayed—Pirate’s Cave? Well, I can only tell you that St. Matthew’s has an establishment that makes Pirate’s Cave look like a cut-rate holiday camp. It’s called St. Matthew’s Golf Club, and the golf course is the main attraction. Quite apart from the huge daily rate for staying there, the annual subscription is… well, I won’t even tell you, because you’d faint. Having thus insured that only the very, very rich can afford to go there, the members take advantage of the fact that it’s a club and blackball any of the very rich whom they consider undesirable.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Needless to say, John and I are")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("not")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("members. However, we found a delightful little inn, run very much like an English pub, called the Anchorage. The rates are quite reasonable, the rooms are simple but attractive, and it’s close to beautiful beaches. The owners are a pleasant couple (British)—but they are moving back to England before the end of the year, so we don’t know what will become of the Anchorage. Anyway, we have booked to go there again in August.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Give our love to Chelsea. We saw Henry’s name in the English papers on St. Matthew’s—something about Chief Superintendent Tibbett making a statement on a murder case. He does lead an exciting life. John says economics is getting to be a duller and more discouraging profession every day.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Love,")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Margaret")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("The Anchorage Inn"), _c('br'), _vm._v("St. Matthew’s"), _c('br'), _vm._v("British Seaward Islands"), _c('br'), _vm._v("August 21")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("My dear Emmy,")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("I’m afraid this is rather a sad letter, in spite of the fact that St. Matthew’s is just as lovely as ever. Ann and Harry (the owners of the Anchorage) are definitely retiring in October, and so far they haven’t found a buyer for the inn—that is, other than the Golf Club, who wants to turn it into staff quarters. So it looks as though this will be our last visit to our beautiful and special island. Still, we are making the most of it. The snorkeling in Cedar Valley Bay is fantastic. I saw a parrot fish this afternoon, about a foot long and all colors of the rainbow and not a bit scared—I could have touched him. John has been doing a lot of horseback riding and sailing. I think he hates the idea of going back to Washington even more than I do. He’s talking a lot about early retirement, so perhaps you’ll see us back in London sooner than you expect!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Love,"), _c('br'), _vm._v("Margaret")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Printed matter.")]), _c('br'), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Postmark St. Matthew’s, B.S.I., October 30")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("John and Margaret Colville are delighted to inform their friends, both old and new, that they are taking over the Anchorage Inn, St. Matthew’s, B.S.I., on the retirement of Harry and Ann Parsons. The Anchorage is at present closed for redecoration, but will open for the Christmas season on December 15th. Bookings accepted now. Looking forward to seeing you!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("The Anchorage Inn"), _c('br'), _vm._v("St. Matthew’s"), _c('br'), _vm._v("British Seaward Islands"), _c('br'), _vm._v("January 10")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("My dear Emmy,")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Bless you for your Christmas card and your sweet letter. I’m sorry about the nasty little printed announcement, but, as you can imagine, life has been hectic.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("It all happened in such a hurry. By one of those unbelievable coincidences, John heard all within a week that (a) he had inherited a legacy which would just cover the down payment on the Anchorage, and (b) that he was eligible for an early-retirement scheme, with a good pension. You may have gathered from my letters that this idea has been simmering in our minds for some time—but it seemed just like a pipe dream.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("In fact, it was rather like a scene in an old-time melodrama where the hero is about to face the firing squad when a messenger gallops up shouting “Don’t shoot! He’s reprieved!” We called Ann and Harry to discuss the situation at leisure, only to hear that they were due to sign a contract with the Golf Club the very next day! We took the night flight down, and by lunchtime the deal was fixed, we’d paid our deposit, and Major Chatsworth (that’s the secretary of the Golf Club) was miffed as all hell. Actually, he’s a nice person and we’re good friends now. I don’t think his wife has quite forgiven us yet—she’s something of a character.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("We’ve never worked so hard in our lives, but we love it. I never thought we’d get the redecoration done in time for our December 15th opening—but somehow everything got done, mostly thanks to Sandy. He’s our barman, right hand, and general factotum, a native-born Matthewsian and a tower of strength, both literally and figuratively. He’s only twenty-three, but he’s got brains as well as brawn, and I just don’t know what we’d do without him.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Anyhow, we had a couple of guests booked in from the very first day, and for Christmas every room was full—all six of them! It was hectic, but we managed, and I think they all had a good time. In fact, two couples booked in for next Christmas before they left! Major Chatsworth and the other people from the Golf Club are being very friendly and helpful—that’s what we like so much about this island. Everybody is pleasant and welcoming, and as far as we can see there’s absolutely no racial tension, which is more than you can say for a lot of places around here. There’s a small group of young men—out-islanders who have come here to find work— who tend to congregate in one of the bars and breathe fire at the fat cats up at the Golf Club, but Sandy says it’s just a lot of hot air and there are no real Matthewsians involved. He says they knew very well what they were doing when they refused to “go independent” along with Tampica, and they’re perfectly happy as a Crown Colony.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("By the way, we were honored last week by a visit from His Excellency, the governor of the British Seawards, doing the rounds of his parish (the seat of government is on St. Mark’s, about twenty miles away). He stayed at the Golf Club, of course, but Major Chatsworth brought him over here one evening for a drink. He’s a nice old boy—name of Sir Geoffrey Patterson. Quite bright, I think. Has some good ideas about the future of the islands—getting some source of income going aside from just tourism.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("I need hardly say that John and I would adore welcoming you and Henry as our guests—but of course I know it’s a horribly long way from England. Still, do think about it.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Love to you both,"), _c('br'), _vm._v("Margaret")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("From the")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Times,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("London, March 21")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("U.S. SENATOR MURDERED")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("The wave of racial violence that has been sweeping the Caribbean now appears to have reached the small British island of St. Matthew’s in the British Seawards. U.S. Senator Brett Olsen was found dead yesterday on the links of the exclusive St. Matthew’s Golf Club, where he was spending a holiday. Victim of an apparently senseless and motiveless crime, the senator had been savagely attacked and mutilated with a machete or native knife.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("The crime follows the pattern of similar incidents on other islands in which young black men have attacked and killed total strangers, who are always both white and wealthy. Up until now, however, St. Matthew’s has been known for its exceptionally smooth race relations. Sir Geoffrey Patterson, the governor of the British Seaward Islands, has expressed profound shock and regret at the murder. Sanderson Robbins, 23, a native of St. Matthew’s, has been arrested and charged with the crime.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Senator Olsen will best be remembered for his work on the so-called Olsen committee, which has done much to encourage and stabilize the cotton industry of the United States.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("The Anchorage Inn"), _c('br'), _vm._v("St. Matthew’s"), _c('br'), _vm._v("British Seaward Islands"), _c('br'), _vm._v("March 21")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Oh, Emmy, the most terrible thing has happened and we are distraught and Henry is the only person we can think of to help us.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("A very important American senator was found dead on the golf course on Tuesday, and the police have arrested")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Sandy,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("of all people, and charged him with murder!!! They’ve got what seems on the surface to be a very good case against him, with a witness and everything, and I know Sandy’s story sounds thin, but you’ve got to believe me, Emmy, Sandy is")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("innocent.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("He just simply couldn’t and wouldn’t have done such an awful thing—he’s the kindest, sweetest person on earth, and he’d only met this Olsen character a couple of times, in the bar here. He had absolutely no reason to attack him and carve him up with a machete—if it wasn’t tragic it would be ridiculous even to think of it. What’s more, the whole island is furious and upset at Sandy’s arrest, and that little gang of out-islanders I told you about is all set to make trouble, you mark my words. Now, of course, people are saying that Sandy was one of them, but he")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("wasn’t")]), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Emmy, I may be just silly, but I can’t help remembering how Henry cleared up that affair at the Tampican embassy in Washington, and I know that if anybody can help poor Sandy, it’s him—Henry, I mean. Please, please, won’t you both fly out here")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("as soon as possible")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("and stay with us and see what can be done? John and I will pay your fares, if that’s a difficulty. We’d do anything for Sandy’s sake—and for the sake of St. Matthew’s, come to that. Tourists are leaving the Golf Club in droves, nobody dares go onto the links anymore, and we’ve had three cancellations since the news broke yesterday in the American press. Somebody really horrible and frightening must have set out to do this to the island—and to poor Sandy— and it just must")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("not")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("be allowed to happen. We know Henry can help us,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("and we beg him to. Please cable your answer as soon as possible. You get here from England via Antigua and St. Mark’s by air, then take a boat. Please help us… Margaret")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("(In a different hand)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Henry, old man, I realize that Margaret is somewhat incoherent, but the situation is grave, both on personal and political levels. If there is any way you could cooperate, we’d really appreciate it.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("John")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("From the")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Times,")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("London, March 23")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("UNREST ON CARIBBEAN ISLAND")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Further racial unrest appears to be breaking out on the Caribbean island of St. Matthew’s, where U.S. Senator Brett Olsen was murdered last Tuesday. Reports reaching Tampica tell of a small band of young blacks roaming the streets, overturning and burning a white-owned car and breaking several windows. The governor of the B.S.I, Sir Geoffrey Patterson, visited St. Matthew’s yesterday, but so far no official comment on the disturbances has been issued.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Interoffice Memo. Dated March 26")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("From: Assistant Commissioner’s office")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("To:"), _c('span', {
    staticClass: "space"
  }), _vm._v("Chief Superintendent Tibbett, Room 508, C Division.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("The Assistant Commissioner would like to see Chief Superintendent Tibbett in his office at 9:00 A.M. tomorrow, March 27, in connection with a special assignment overseas. (Signed) Indecipherable for Assistant Commissioner")])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "scale1",
    attrs: {
      "alt": "chpt_fig_001",
      "src": "Images/chpt_fig_001.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Ah, good morning, Tibbett. Sit down.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Thank you, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Well, I’ve got what you might call a little plum of a job in mind for you, Tibbett—although it may turn out to be tricky. You know the Caribbean, I believe?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I’ve been there once, sir. To Tampica. In connection with the Ironmonger case—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“That’s right. You know the area. You have connections with the Tampican government.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I’ve met the prime minister, yes, sir. I wouldn’t say the connection was very close.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Never mind. It’s a connection, which is more than any of my other senior officers have. You’ve seen the papers? This affair on St. Matthew’s, in the Seawards?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Yes, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I’ve had the High Commissioner on to me. The situation is in hand, but it could turn ugly. There seems to be no doubt that the young man they’ve arrested is guilty, but apparently he’s a popular character, and unfortunately the chief of police is a white man. This has paved the way for all sorts of fire-raising rumors about racial influence and political bias and heaven knows what else. As I understand the situation, Tibbett, the troublemakers are just a small group of itinerant workmen, not people from St. Matthew’s at all. The islanders themselves voted to remain British, and have been perfectly happy—until now. However, this is just the sort of incident that could lead to inflamed passions and…well…”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“If I might say so, sir—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“The High Commissioner has been in touch with the governor, who is currently on St. Matthew’s, and they both agree that the only way to avert a dangerous situation is to put the investigation of the crime into entirely neutral hands. In other words, they’ve asked us to help.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Sir, I must tell you that—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Let me finish, please, Tibbett. My plan is that you and Sergeant Reynolds should fly out to St. Matthew’s and take charge of the investigation. You will report to Inspector Montague, the island’s chief of police, who made the arrest. He will give you all the details. As I said—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“But, sir—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“As I said, it’s apparently an open-and-shut case, but it will make all the difference if the local people realize that it is in the hands of a completely impartial and expert detective from London. You will also keep in close touch with the governor, Sir Geoffrey Patterson—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Sir, I—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“You will stay at the Golf Club, of which you will become a temporary member, and Sergeant Reynolds at a smaller establishment known as the Anchorage Inn. Transportation is being arranged for tomorrow—my office has all the details. I shall expect you to report frequently to me. You must realize that this is not just another murder investigation, Tibbett. It is also a diplomatic mission of some delicacy. Well—any questions?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Yes, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Oh. Really? Well?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I’m afraid I can’t undertake the assignment, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“You’re…what?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I have to disqualify myself, sir. You see, I wouldn’t be an impartial investigator.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“This is ridiculous, Tibbett. Explain yourself.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I’ve been trying to, sir. You see, my wife and I are old friends of the Colvilles—the couple who run the Anchorage Inn. The suspect under arrest is their barman. In fact, my wife had a letter from Mrs. Colville only this morning, ironically enough, asking if I couldn’t go over there and try to sort the case out. She’s considerably worked up about it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Hm. That’s not so good, Tibbett, I agree. These Colville people are white, I presume?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Yes, sir. A retired economist and his wife. They only took over the inn last Christmas.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I see. It certainly wouldn’t do if it were known that you were a friend of these white people, who must be eager to see this fellow—what’s his name?—this Sanderson Robbins convicted and sentenced as soon as—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Oh, no, sir. You misunderstand me. The Colvilles are passionately convinced that Sandy—that Robbins is innocent. That’s why they asked for my help, to try to clear him. They know him well, you see, and obviously they like him very much. They think he’s been framed in some way.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“They do, do they? Now this is interesting, Tibbett. This puts a different complexion on things. Do the islanders in general know that these Colvilles are rooting for Robbins?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I should think they must, sir. Margaret and John are both pretty outspoken people, and the letter made it plain how strongly they feel.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Well, now, Tibbett, this could be to our advantage. If it were known that you and your wife were friends of these people—that you could be presumed to have a bias in Robbins’s favor, if anything—then your eventual conclusion that he was guilty could not possibly be suspect. Yes, the more I think of it, the more I think that a leaning in")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("that")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("direction would be positively helpful. I suggest that Mrs. Tibbett should travel with you and that you should both stay at the Anchorage Inn. That does raise a small problem, however. You will need the assistance of Sergeant Reynolds, and you know our policy of accommodation for officers of different ranks.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Why shouldn’t Sergeant Reynolds stay at the Golf Club, sir? It’ll be useful to have somebody there, and I believe his handicap is coming down nicely. I don’t play golf myself, so it would be a very suitable arrangement.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“You know what sort of a place it is?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Yes, sir. Gold-plated and ultrasnobbish. British owned, but patronized almost entirely by Americans.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“You think they’d accept Reynolds as a temporary member?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“They’d have to, wouldn’t they, sir?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Yes, in the circumstances, I suppose they would. Might do ’em a bit of good. Cheer the place up a bit.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“That’s what I thought, sir. And another thing—I assume that my presence on the island will get a fair bit of publicity, but there’s no need for anybody to know who Reynolds is, is there?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I suppose the secretary will have to know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“All right, just the secretary. Nobody else. It will give him much more freedom to operate.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“A good idea, Tibbett. A very good idea.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5d273fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chapter01.vue
// module id = 72
// module chunks = 0